import { useQuery } from "@tanstack/react-query";
import { MiscellaneousKeys } from "web_myplann/Api/Miscellaneous/miscKeys";
import { getAppV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";
import { duration, TimeUnit } from "web_myplann/Infrastructure/Utils/TimeUtils";

type Options = {
	staleTime?: number;
	refetchOnMount?: boolean | "always";
};

export const useApplicationInformationQuery = (
	enabled = true,
	{
		staleTime = duration(5, TimeUnit.Minutes), // avoid refetching on navigation
		refetchOnMount = true,
	}: Options = {},
) => {
	return useQuery({
		queryKey: MiscellaneousKeys.appColor(),
		queryFn: processResponse(() => getAppV2()),
		enabled,
		staleTime,
		refetchOnMount,
	});
};
